import { useEffect, useState } from "react";
import { _ManufacturingStardard } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import usePaginator from "../../theme/Component/usePaginator";
import { Modal } from "../../theme/Component/Modal";
import { SelectProductiveProcessType } from "../ProductiveProcessType/SelectProductiveProcessType";
import { SelectProductEditor } from "./Components/SelectProductEditor";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { toast } from "react-toastify";


interface confProps {
    canEdit?: true;
    label?: string;
}

interface Props {
    IDManufacturingStardard: number;
    returnData: Function;
    ConfigProps?: confProps;
}


export const ManufacturingStandarsEditor = ({ IDManufacturingStardard, ConfigProps, returnData }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_ManufacturingStardard);
    const paginador = usePaginator();
    const [registers, setRegisters] = useState<number>(15);
    const [processID, setProcessID] = useState<number>(NaN);
    const [product, setProduct] = useState<number>(NaN);

    const [regex, setRegex] = useState<string>("");

    const [modal, setModal] = useState<any>({ name: "Estandares de Producción", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (IDManufacturingStardard) {
            getManufacturing();
        }
    }, [IDManufacturingStardard])

    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getManufacturing = () => {
        instance.getManufacturingStardardByID(IDManufacturingStardard).then(
            (resp) => {
                setBean(resp)
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const getLista = () => {
        instance.getManufacturingStardardByCode(regex != "" ? regex : null, processID ?? null, product ?? null, paginador.page, registers).then(
            (resp) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (registers ?? 15));
                    paginador.setRegiPerPage(registers)

                    setLista(resp.List)
                }
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDManufacturingStardard', visible: true },
        { title: 'Codigo', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo de Proceso Productivo', property: 'ProductiveProcessTypeName', visible: true },
        { title: 'Producto Final', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Almacén Destino', property: 'StoreName', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },

    ]

    const returnDataBean = () => {
        if (bean.IDManufacturingStardard) {
            if (returnData) {
                returnData(bean);
                setModal({ ...modal, "view": false })
            }
        } else {
            toast.error("Debe seleccionar un Estandar de Produccion Valido");
        }
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                {bean.IDManufacturingStardard ?
                    <label>Estandar de Producción</label>
                    :
                    <label>{ConfigProps?.label ?? "Estandar de Producción"}</label>
                }
                <input className="form-control" aria-label="order production´s"
                    aria-describedby="button-addon2" placeholder='Buscar...'
                    value={bean.IDManufacturingStardard ? `${bean.Code} - ${bean.Name} - ${bean.MeasurementUnitName}` : ""}
                    onClick={() => { setModal({ ...modal, 'view': true }); }}
                />
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} onSubmitLabel="Seleccionar Orden" eventModal={() => { returnDataBean() }} >
                    <div className="row">
                        <div className="col-md-4">
                            <label>Texto</label>
                            <input type="text" className="form-control" value={regex} onChange={(e) => { setRegex(e.target.value) }} />
                        </div>
                        <div className="col-md-4">
                            <SelectProductiveProcessType idSelector={processID} onChange={(e) => { setProcessID(e) }} />
                        </div>
                        <div className="col-md-4">
                            <SelectProductEditor filterType={3} label="Producto Final" value={product} onChange={(e) => { setProduct(e.IDProduct) }} />
                        </div>
                        <div className="col-md-3 mt-2">
                            <BasicButton icon="ri-search-line" eventClick={() => { getLista() }} children={"Buscar"} />
                        </div>
                        <div className="col-md-12">
                            <BasicTable
                                head={head}
                                body={lista}
                                rowSet={setBean}
                                pageTop={paginador.page}
                                next={paginador.next}
                                back={paginador.back}
                                records={paginador}
                                customRows={registers}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
};